import type {
	GetPetNamesParams,
	GetAllPetNamesParams,
	PetNamesResponse,
} from './types'

interface ErrorResponse {
	error: string
}

const API_BASE_URL = '/api/petNames'

const fetchOptions: RequestInit = {
	headers: {
		'Content-Type': 'application/json',
	},
}

const handleFetchError = (
	response: Response,
	data: PetNamesResponse | ErrorResponse
): PetNamesResponse => {
	if (!response.ok || 'error' in data) {
		throw new Error(
			'error' in data
				? data.error
				: `HTTP error! status: ${response.status}`
		)
	}
	return data
}

const fetchPetNames = async (url: string): Promise<string[]> => {
	const response = await fetch(url, fetchOptions)
	const data = (await response.json()) as PetNamesResponse | ErrorResponse
	const result = handleFetchError(response, data)
	return result.data[0]?.names ?? []
}

export const getPetNames = async (
	params: GetPetNamesParams
): Promise<string[]> => {
	const searchParams = new URLSearchParams({
		locale: params.locale,
		...(params.required && {required: params.required.join(',')}),
	}).toString()

	return fetchPetNames(`${API_BASE_URL}/search?${searchParams}`)
}

export const getAllPetNames = async (
	params: GetAllPetNamesParams
): Promise<string[]> => {
	const searchParams = new URLSearchParams({
		locale: params.locale,
	}).toString()

	return fetchPetNames(`${API_BASE_URL}/all?${searchParams}`)
}
